!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("formik"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "formik", "@material-ui/core"], t) : t((e = e || self)["multi-select"] = {}, e.React, e.formik, e.core);
}(this, function (e, t, l, n) {
  "use strict";

  var r = "default" in t ? t.default : t,
      _a = function a() {
    return (_a = Object.assign || function (e) {
      for (var t, l = 1, n = arguments.length; l < n; l++) for (var r in t = arguments[l]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);

      return e;
    }).apply(this, arguments);
  };

  e.MultiSelect = function (e) {
    var u = e.name,
        i = e.items,
        o = e.placeholder,
        c = function (e, t) {
      var l = {};

      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (l[n] = e[n]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;

        for (n = Object.getOwnPropertySymbols(e); r < n.length; r++) t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (l[n[r]] = e[n[r]]);
      }

      return l;
    }(e, ["name", "items", "placeholder"]),
        f = u + "-multi-select",
        m = u + "-multi-select-label",
        d = o || "Choose any",
        s = r.useRef(null),
        v = r.useState(0),
        p = v[0],
        y = v[1];

    return t.useEffect(function () {
      s && s.current && y(s.current.offsetWidth);
    }, []), r.createElement(l.Field, {
      name: u
    }, function (e) {
      var t = e.field,
          l = e.form;
      return r.createElement(n.FormControl, {
        fullWidth: !0,
        variant: "outlined"
      }, r.createElement(n.InputLabel, {
        ref: s,
        id: m
      }, d), r.createElement(n.Select, _a({
        labelId: m,
        id: f,
        multiple: !0,
        value: t.value,
        onChange: function onChange(e) {
          var n = e.target.value;
          n.includes("all") && l.setFieldValue(t.name, ["all"]), n.includes("none") && l.setFieldValue(t.name, []), n.includes("all") || n.includes("none") || l.setFieldValue(t.name, n);
        },
        input: r.createElement(n.OutlinedInput, {
          labelWidth: p,
          name: "age",
          id: f
        }),
        renderValue: function renderValue(e) {
          var t, l;
          return e.includes("all") ? null === (t = i.find(function (e) {
            return "all" === e.value;
          })) || void 0 === t ? void 0 : t.label : e.includes("none") || 0 === e.length ? null === (l = i.find(function (e) {
            return "none" === e.value;
          })) || void 0 === l ? void 0 : l.label : i.filter(function (t) {
            return e.indexOf(t.value) > -1;
          }).map(function (e) {
            return e.label;
          }).join(", ");
        }
      }, c), i.map(function (e) {
        return "all" === e.value ? r.createElement(n.MenuItem, {
          key: e.value,
          value: e.value
        }, r.createElement(n.ListItemText, {
          primary: "Select All"
        })) : "none" === e.value ? r.createElement(n.MenuItem, {
          key: e.value,
          value: e.value
        }, r.createElement(n.ListItemText, {
          primary: "Deselect All"
        })) : r.createElement(n.MenuItem, {
          key: e.value,
          value: e.value
        }, r.createElement(n.Checkbox, {
          color: "primary",
          value: e.value,
          checked: t.value.includes(e.value) || t.value.includes("all")
        }), r.createElement(n.ListItemText, {
          primary: e.label
        }));
      })));
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});